import { useGetEmployeesNameByBadgeNoQuery } from "shared/queries/employee/employee.generated";
import { truncateEmployeeName } from "utils/formats";

export function useEmployeeInfo(badgeId: string | null): { name: string } {
  const { data } = useGetEmployeesNameByBadgeNoQuery({
    variables: { input: { badgeNumbers: badgeId ? [badgeId] : [] } },
    skip: !badgeId,
  });

  const displayName = data?.getEmployees.find(
    (employee) => employee.badgeNo === badgeId,
  )?.displayName;

  return { name: displayName ? truncateEmployeeName(displayName) : "" };
}
